(() => {
  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/helpers/helpers.js
  function getTransitionEndEventName() {
    const transitions = {
      "transition": "transitionend",
      "OTransition": "oTransitionEnd",
      "MozTransition": "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
    };
    let bodyStyle = document.body.style;
    for (let transition in transitions) {
      if (bodyStyle[transition] != void 0) {
        return transitions[transition];
      }
    }
  }

  // src/js/components/paginationinput.js
  var PaginationInput = class {
    constructor(parent, current_page, limit, input) {
      this.parent = parent;
      this.current_page = current_page;
      this.limit = limit;
      this.input = input;
      this.settings = {
        is_edited: "is-edited"
      };
    }
    static create() {
      const parent = window.Store.app.theBody.querySelector(".js-pagination-current");
      const current_page = parent ? parent.querySelector(".js-pagination-begin") : null;
      const limit = parent ? parent.querySelector(".js-pagination-end") : null;
      const input = parent ? parent.querySelector("input") : null;
      if (!parent || !current_page || !limit || !input)
        return null;
      const input_object = {
        item: input,
        link: input.dataset.link,
        max: parseInt(input.dataset.max),
        page: parseInt(input.dataset.page)
      };
      const obj = new PaginationInput(parent, current_page, limit, input_object);
      obj.listener();
      return obj;
    }
    listener() {
      const self = this;
      this.parent.addEventListener("click", (e) => {
        this.parent.classList.add(`${this.settings.is_edited}`);
        this.parent.addEventListener(getTransitionEndEventName(), function _listener() {
          self.input.item.select();
          self.parent.removeEventListener(getTransitionEndEventName(), _listener, true);
        }, true);
      });
      this.input.item.addEventListener("blur", () => {
        this.parent.classList.remove(`${this.settings.is_edited}`);
      });
      this.input.item.addEventListener("keyup", (e) => {
        if (isFinite(e.key) && e.key !== " ") {
          if (parseInt(e.target.value) > parseInt(this.input.max) || parseInt(e.target.value) <= 0) {
            e.target.value = this.input.max;
            return;
          }
          return;
        }
        if (isFinite(e.key) == false && e.key !== "Backspace" && e.key !== "Enter") {
          e.target.value = "";
          return;
        }
      });
      this.input.item.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          if (parseInt(e.target.value) !== this.input.page && e.target.value !== "") {
            this.goToUrl(e.target.value);
            return;
          }
          this.parent.classList.remove(`${this.settings.is_edited}`);
          return;
        }
        if (e.code == "Space") {
          e.target.value = this.input.max;
        }
      });
    }
    goToUrl(input_value) {
      let url;
      if (parseInt(input_value) == 1) {
        url = `${this.input.link}`;
      }
      if (parseInt(input_value) > 1) {
        url = `${this.input.link}page/${input_value}`;
      }
      this.parent.classList.remove(`${this.settings.is_edited}`);
      window.Store.app.barba.go(url);
    }
  };
  function render() {
    window.Store.components.paginationinput.obj = PaginationInput.create();
  }
  window.Store.components.paginationinput = {
    obj: null,
    render: null
  };
  window.Store.components.paginationinput.render = render;
})();
